<template>
  <div class="datos">
    <b-overlay variant="success" opacity="0.5" :show="Esperar">
      <b-row>
        <b-col>
          <div class="my-1 mx-0 text-center">
            <router-link to="/courier/reportes">
              <img src="/logo4.svg" />
            </router-link>
          </div>
        </b-col>
        <b-col class="pt-2 text-center" cols="8">
          <H3 class="title">Listado de entregas</H3>

          <div>Total de Envios: {{ envios.length }}</div>
        </b-col>
      </b-row>

      <b-table-simple :sort-compare="OrdenarSi" :sort-by.sync="OrdenarBy" small>
        <b-thead>
          <b-th>No</b-th>
          <b-th>Guia</b-th>
          <b-th>Recibe</b-th>
          <b-th>RGN</b-th>
          <b-th>PAQ</b-th>
          <b-th>Entrega</b-th>
          <b-th></b-th>
        </b-thead>
        <b-tbody>
          <b-tr v-for="env in enviox" :key="env.Guia">
            <b-td>{{ env.No }}</b-td>
            <b-td>{{ env.Guia }}</b-td>
            <b-td>{{ env.Recibe }}</b-td>
            <b-td>{{ env.RGN }}</b-td>
            <b-td>{{ env.PAQ }}</b-td>
            <b-td>{{ env.Entrega }}</b-td>
            <b-td>
              <opcion @onUpdateOrden="updateOrden" :Orden="Viaje" :Envio="env" />
            </b-td>

          </b-tr>
        </b-tbody>
      </b-table-simple>
    </b-overlay>
  </div>
</template>

<script>
import firebase from "firebase/app";
import "firebase/firestore";
import Opcion from "./otros/OpcionOrden.vue";

if (!firebase.apps.length) firebase.initializeApp({ projectId: "diazvelizexpress" });
else firebase.app();

const db = firebase.firestore();

export default {
  components: { Opcion },
  methods: {
    updateOrden(rq) {
      db.collection("Viaje")
        .doc(this.viaje)
        .update({ Orden: rq });
    },
    Ordena(rs) {
      rs = rs.sort((a, b) => {
        let na = a.No || 9999;
        let nb = b.No || 9999;

        if (na < nb) return -1;
        else if (na > nb) return 1;
        else return 0;
      });

      return rs;
    },
    soltar() {
      this.dragging = false;
    },
    CambioDrag(a, b) {
      console.log(a, b);
    },
    OrdenarSi(a, b, key) {
      if (key == "No") {
        let v = parseInt(a[key]) || 999999;
        let w = parseInt(b[key]) || 999999;
        return v - w;
      } else {
        return false;
      }
    },
    AsignarOrden(v) {
      let orden = [...this.Viaje] || [];

      let existe = false;

      orden.forEach((item) => {
        if (item.Guia == v.Guia) existe = true;
      });

      if (existe == false) {
        orden.push({ No: this.NextOrden, Guia: v.Guia });

        db.collection("Viaje")
          .doc(this.viaje)
          .update({ Orden: orden });
      }
    },
  },
  mounted() {
    this.$bind("EnviosDB", db.collection("Envios")).then(() => {
      this.Esperar = false;
    });
  },
  computed: {
    NextOrden() {
      let rs = 0;
      let orden = [...this.Viaje];

      orden.forEach((v) => {
        if (v.No > rs) rs = v.No;
      });

      rs++;
      return rs;
    },
    Viaje() {
      let rs = this.Viajes.filter((tr) => tr.id == this.viaje)[0];

      return rs.Orden || [];
    },
    enviox() {
      let envs = this.envios;

      if (envs.length < 1) return [];

      let rs = envs.map((item) => {
        let Lista = [...this.Viaje];

        let orden = Lista.filter((it) => it.Guia == item.Guia);

        orden = orden[0]?.No || null;

        return {
          No: orden,
          Guia: item.Guia,
          Recibe: item.Recibe.Nombre,
          RGN: item.Recibe.Region,
          Celular: item.Recibe.Celular,
          PAQ: item.PAQ,
          Entrega: item.Entrega,
        };
      });

      return this.Ordena(rs);
    },
    envios() {
      let qr = this.EnviosDB.filter((env) => {
        return env.Entregado !== true;
      }).map((item) => {
        let cli = this.Clientes.filter((cli) => cli.id == item.Recibe)[0];
        let cant = item.Contenido.filter((p) => {
          return p.Tipo == "Paquete";
        }).length;

        return {
          Guia: item.NoGuia,
          Recibe: cli,
          PAQ: cant,
          Entrega: item.Entrega,
        };
      });

      return qr || [];
    },
  },

  firestore: {
    Clientes: db.collection("Cliente"),
    Viajes: db.collection("Viaje"),
  },

  data() {
    return { Esperar: true, EnviosDB: [], Envios: [], Clientes: [], Viajes: [], OrdenarBy: "No", dragging: false };
  },
  props: ["viaje"],

  beforeCreate() {
    this.$root.$emit("Imprimir", { ok: true });
  },
};
</script>

<style scoped>
.datos {
  width: 19.5cm;
  border: 1p solid black;
}
.tabla {
  font-size: 14px;
  margin-top: 20px;
}
</style>
